/* eslint-disable */ import { assertNumber, assertString, attributeSelectionComponent, genericDimensionComponent, memoEval, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
import { AnchorPointPosition } from '../model/index.js';
export const featureSettingComponents = [
    attachAdminComponent.withComponent(violationComponent, 'default', true).withEntity('FeatureSetting').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachAdminComponent.withComponent(genericDimensionComponent, 'offsetX', true).withEntity('FeatureSetting').attach(memoEval((self)=>[
            self.offsetX
        ], (offsetX)=>({
            value: offsetX,
            min: -100,
            max: 100,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        return {
            offsetX: state.value
        };
    }),
    attachAdminComponent.withComponent(genericDimensionComponent, 'offsetY', true).withEntity('FeatureSetting').attach(memoEval((self)=>[
            self.offsetY
        ], (offsetY)=>({
            value: offsetY,
            min: -100,
            max: 100,
            unit: 'mm'
        })), (state)=>{
        assertNumber(state.value);
        return {
            offsetY: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSelectionComponent, 'plateType', true).withEntity('FeatureSetting').attach(memoEval((self)=>[
            self.plateType,
            self.$plateTypeOptions
        ], (plateType, $plateTypeOptions)=>({
            value: plateType,
            options: $plateTypeOptions
        })), (state)=>{
        assertString(state.value);
        return {
            plateType: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSelectionComponent, 'featureType', true).withEntity('FeatureSetting').attach(memoEval((self)=>[
            self.featureType,
            self.$featureTypeOptions
        ], (featureType, $featureTypeOptions)=>({
            value: featureType,
            options: $featureTypeOptions
        })), (state)=>{
        assertString(state.value);
        return {
            featureType: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSelectionComponent, 'anchorPoint', true).withEntity('FeatureSetting').attach(memoEval((self)=>[
            self.anchorPointPosition,
            self.$anchorPointPositionOptions
        ], (anchorPointPosition, $anchorPointPositionOptions)=>({
            value: anchorPointPosition,
            options: $anchorPointPositionOptions
        })), (state)=>{
        AnchorPointPosition.assert(state.value);
        return {
            anchorPointPosition: state.value
        };
    })
];

//# sourceMappingURL=feature-setting.js.map